/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inventory_CommandInputs */

const en_inventory_command = /** @type {(inputs: Inventory_CommandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inventory Command`)
};

const es_inventory_command = /** @type {(inputs: Inventory_CommandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mando de inventario`)
};

const fr_inventory_command = /** @type {(inputs: Inventory_CommandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commande d'inventaire`)
};

const de_inventory_command = /** @type {(inputs: Inventory_CommandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inventar-Kommando`)
};

const ja_inventory_command = /** @type {(inputs: Inventory_CommandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`インベントリコマンド`)
};

const zh_inventory_command = /** @type {(inputs: Inventory_CommandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`库存指令系统`)
};

const ar_inventory_command = /** @type {(inputs: Inventory_CommandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أوامر المخزون`)
};

const id_inventory_command = /** @type {(inputs: Inventory_CommandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Komando Inventaris`)
};

const it_inventory_command = /** @type {(inputs: Inventory_CommandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comando Inventario`)
};

const ru_inventory_command = /** @type {(inputs: Inventory_CommandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Управление инвентарем`)
};

const pt_inventory_command = /** @type {(inputs: Inventory_CommandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comando de Inventário`)
};

const ko_inventory_command = /** @type {(inputs: Inventory_CommandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`인벤토리 커맨드`)
};

/**
* | output |
* | --- |
* | "Inventory Command" |
*
* @param {Inventory_CommandInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const inventory_command = /** @type {((inputs?: Inventory_CommandInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inventory_CommandInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_inventory_command(inputs)
	if (locale === "es") return es_inventory_command(inputs)
	if (locale === "fr") return fr_inventory_command(inputs)
	if (locale === "de") return de_inventory_command(inputs)
	if (locale === "ja") return ja_inventory_command(inputs)
	if (locale === "zh") return zh_inventory_command(inputs)
	if (locale === "ar") return ar_inventory_command(inputs)
	if (locale === "id") return id_inventory_command(inputs)
	if (locale === "it") return it_inventory_command(inputs)
	if (locale === "ru") return ru_inventory_command(inputs)
	if (locale === "pt") return pt_inventory_command(inputs)
	return ko_inventory_command(inputs)
});